import axios from "axios";

const client = axios.create();

export const setToken = token => {
  client.defaults.headers.common["x-auth-token"] = token;
};

client.defaults.baseURL = process.env.REACT_APP_API_URL;

// if (process.env.NODE_ENV === "production") {
//   client.defaults.baseURL = process.env.REACT_APP_API_URL;
//   // client.defaults.baseURL = "http://ctcr2019.devmon.kr";
//   // client.defaults.baseURL = "https://ctcr.snuh.org";
//   // client.defaults.baseURL = "http://localhost:8080";
// }

export default client;
